import { useEffect } from 'react';
import { MonthlyStatementDetails } from 'src/apis/capacity-management/types';
import { MonthlyStatementsRequest } from 'src/apis/capacity-management/use-monthly-statements';
import { useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type HookConfig = {
  monthlyStatements: MonthlyStatementsRequest;
  monthlyStatementId: string;
};

type RequestConfig = {
  instanceUrlTemplate: string;
  monthlyStatementId: string;
};

export function useMonthlyStatement({
  monthlyStatements,
  monthlyStatementId,
}: HookConfig) {
  const monthlyStatement = useAxios(
    (
      axios,
      signal,
      { instanceUrlTemplate, monthlyStatementId }: RequestConfig
    ) => {
      const url = urlTemplate.parse(instanceUrlTemplate).expand({
        monthlyStatementId,
      });
      return axios.request<MonthlyStatementDetails>({
        signal,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!monthlyStatements.response) return;

    const instanceUrlTemplate =
      monthlyStatements.response.data._links.instance.href;
    monthlyStatement.execute({
      instanceUrlTemplate,
      monthlyStatementId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    monthlyStatements.response?.data._links.instance.href,
    monthlyStatementId,
  ]);

  return monthlyStatement;
}

export type MonthlyStatementRequest = ReturnType<typeof useMonthlyStatement>;
